import React, { useState, useEffect } from "react";
import { InfoCircleOutlined } from '@ant-design/icons';
import CrudButtons from "components/button/crudbuttons";
import { detectUserEnvironment } from "../../utils/geoFenceChecker";

export default function System(props) {
  const { ...rest } = props;

  const [envInfo, setEnvInfo] = useState(null);

  useEffect(() => {
    const detect = async () => {
      const info = await detectUserEnvironment();
      setEnvInfo(info);
    };

    detect();
  }, []);

  document.documentElement.dir = "ltr";

  return (
    <div className="relative flex h-full w-full">    
      <div className="flex h-full w-full bg-lightPrimary dark:!bg-intsamis-900 justify-center">
        <main className={`panel-main-wrapper`}>
          <div className="h-full">
            <div className="pt-2 mx-auto mb-auto h-full min-h-[60vh] p-2 md:pr-2">
              <div className="mt-16 mb-16 mt-3 flex flex-column items-center gap-5 max-w-[400px] mx-auto">
                <InfoCircleOutlined style={{ fontSize: '72px', color: '#65a30d'}}/>
                <div>
                  {envInfo && (
                    <div className="text-sm text-gray-800">
                      <p><strong>OS:</strong> {envInfo.os}</p>
                      <p><strong>Detected Province:</strong> {envInfo.province ?? 'N/A'}</p>
                      <p><strong>Source:</strong> {envInfo.source ?? 'Unavailable'}</p>
                      <p><strong>Status:</strong> {envInfo.reason ?? 'Location detected'}</p>
                    </div>
                  )}
                </div>
              </div> 
              <CrudButtons className="!text-center" 
                mode='view' 
                backUrl="/home"
                backLabel="Home"
                withEdit={false}/>             
            </div>
            <div className="p-3"></div>
          </div>
        </main>
      </div>
    </div>
  );
}
